import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "HighlightArrow",
  "use": "HighlightArrow-usage",
  "viewBox": "0 0 16 8",
  "content": "<symbol viewBox=\"0 0 16 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"HighlightArrow\">\n  <path d=\"M12.01 3L0 3L0 5H12.01V8L16 4L12.01 0V3Z\" fill=\"#1B1B1B\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol